export const ELEMENT_TYPE_ZH: { [key: string]: string } = {
  text: '文本',
  image: '图片',
  shape: '形状',
  line: '线条',
  chart: '图表',
  table: '表格',
  video: '视频',
  audio: '音频',
  latex: '公式',
}

export const MIN_SIZE: { [key: string]: number } = {
  text: 20,
  image: 20,
  shape: 15,
  chart: 200,
  table: 20,
  video: 250,
  audio: 20,
  latex: 20,
}